import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/docs/_layout/guide/_provider/')({
  beforeLoad: async ({ context }) => {
    if (!context.apiGuidesData) {
      throw redirect({ to: '/docs' });
    }

    const firstGuide = context.apiGuidesData.pages?.[0]?.artifact?.[0];

    if (firstGuide) {
      throw redirect({ search: true, to: '/docs/guide/$artifactName', params: { artifactName: firstGuide.name } });
    }

    throw redirect({ search: true, to: '/docs' });
  },
  preload: false,
});
